
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[slug]/team",
      function () {
        return require("private-next-pages/companies/[slug]/team/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[slug]/team"])
      });
    }
  